// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1YEDM","fileDisabled":"File_fileDisabled__3v9kU"};